import styles from './FJMobileFooterBox.module.less';
import classNames from 'classnames';
// import PropTypes from 'prop-types';
import CloseIcon from './../../../assets/svg/mobile-close.svg?react';
import OkIcon from './../../../assets/svg/ok.svg?react';
import { forwardRef, useImperativeHandle, useState, useEffect } from 'react';
import FJUtil from '../../../util/FJUtil';

const FJMobileFooterBox = (props, ref) => {
    const {
        active,
        children,
        className,
        title,
        hasMask = false,
        titleRight,
        autoClose = true,
        closeCallback,
        iconType = 'close',
    } = props;
    const [isShow, setIsShow] = useState(active);
    useImperativeHandle(
        ref,
        () => ({
            show: value => {
                if (value === undefined) {
                    setIsShow(!isShow);
                } else {
                    setIsShow(value);
                }
            },
        }),
        [isShow],
    );
    useEffect(() => {
        if (!isShow || hasMask || !autoClose) return;
        FJUtil.addEvent(window, 'click', _onclose);
        return () => {
            FJUtil.removeEvent(window, 'click', _onclose);
        };
    }, [isShow]);
    const _onclose = e => {
        // FJUtil.forbidEvent(e);
        setIsShow(false);
        closeCallback && closeCallback();
    };
    const _forbidEvent = e => {
        e.stopPropagation();
        e.preventDefault();
    };
    const _onMaskClick = e => {
        _forbidEvent(e);
        _onclose();
    };
    const cn = classNames(styles.inner, className, isShow ? styles.show : styles.hide);
    const showIcon = iconType === 'ok' ? <OkIcon onClick={_onclose} /> : <CloseIcon onClick={_onclose} />;
    return (
        <div
            className={classNames(styles.box, hasMask ? styles.mask : '', isShow ? styles.show : styles.hide)}
            onClick={_onMaskClick}
        >
            <div className={cn} onClick={_forbidEvent}>
                {title && (
                    <div className={styles.header}>
                        <div className={styles.title_box}>
                            <div className={styles.title}>{title?.toString()}</div>
                            {titleRight && titleRight}
                        </div>
                        {showIcon}
                    </div>
                )}
                {children}
            </div>
        </div>
    );
};
// FJMobileFooterBox.propTypes = {
//     className: PropTypes.string,
//     children: PropTypes.node,
//     active: PropTypes.bool,
// };
export default forwardRef(FJMobileFooterBox);
